<template>
  <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 32 32">
    <path
      d="M16,21.3l-6.7-6.7,1.9-1.9,3.5,3.5V5.3h2.7v10.9l3.5-3.5,1.9,1.9-6.7,6.7ZM8,26.7c-.7,0-1.4-.3-1.9-.8-.5-.5-.8-1.1-.8-1.9v-4h2.7v4h16v-4h2.7v4c0,.7-.3,1.4-.8,1.9-.5.5-1.1.8-1.9.8H8Z"
    />
  </svg>
</template>
